export default __webpack_public_path__ + "static/media/orders-across-ka.076ec3a9.jpeg";